export class ActionComponent {
  reset(): void {};
  active(): boolean { return false; }
}
